import { render } from "./Credits.vue?vue&type=template&id=6b3ca906&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=6b3ca906&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3ca906"]])

export default __exports__